// components/Header.tsx
import React from 'react';
import { UserProfile, Tenant, Role } from '../types';
interface CreditBalanceProps {
  balance:
    | {
        freeRemaining: number;
        paidRemaining: number;
      }
    | null;
}

const CreditBalance: React.FC<CreditBalanceProps> = ({ balance }) => {
  if (!balance) {
    return (
      <div className="text-right border-l border-gray-200 pl-4">
        <p className="font-semibold text-brand-grey text-lg">-</p>
        <p className="text-xs text-gray-500">Total Credits</p>
      </div>
    );
  }

  const totalCredits = (balance.freeRemaining || 0) + (balance.paidRemaining || 0);

  return (
    <div className="text-right border-l border-gray-200 pl-4">
      <p className="font-semibold text-brand-grey text-lg">{totalCredits.toLocaleString()}</p>
      <p className="text-xs text-gray-500">Total Credits</p>
    </div>
  );
};

interface HeaderProps {
  userProfile: UserProfile | null;
  tenant: Tenant | null;
  partner: any | null; // keep as any until you have a Partner type in ../types
  onSignOut: () => void;
  partnerLogoUrl: string;
}
export const Header: React.FC<HeaderProps> = ({ userProfile, tenant, partner, onSignOut, partnerLogoUrl }) => {
  // auth/tenant bootstrap can render Header before these are loaded
  if (!userProfile) return null;
  return (
    <header className="w-full border-b border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-[120px]">
          <img
            src={partnerLogoUrl}
            alt="Partner Logo"
            className="h-8 object-contain"
            onError={(e) => {
              const img = e.currentTarget;
              if (!img.dataset.fallbackApplied) {
                img.dataset.fallbackApplied = '1';
                img.src = '/favicon.png';
              }
            }}
          />
        </div>

        <div className="flex items-center gap-4">
{(() => {
  const role = String((userProfile as any)?.role || '').toUpperCase().trim();
  const isPartnerAdmin = role === String(Role.PARTNER_ADMIN);

  const balance = isPartnerAdmin ? (partner as any)?.creditBalance ?? null : (tenant as any)?.creditBalance ?? null;

  const scopeLabel = isPartnerAdmin ? 'Partner' : 'Tenant';
  const scopeName = isPartnerAdmin
    ? (partner as any)?.partnerName ?? (partner as any)?.name ?? (partner as any)?.partnerId ?? '-'
    : (tenant as any)?.tenantName ?? (tenant as any)?.name ?? '-';

  return (
    <>
      <CreditBalance balance={balance} />
      <div className="text-right">
        <p className="font-semibold text-brand-grey truncate max-w-xs">{userProfile.email}</p>
        <p className="text-xs text-gray-500">
          {scopeLabel}: {scopeName}
        </p>
      </div>
    </>
  );
})()}

          <button
            type="button"
            onClick={onSignOut}
            className="px-4 py-2 bg-brand-orange text-white font-semibold rounded-md hover:bg-opacity-90 transition-colors duration-200 shadow-sm"
            aria-label="Sign out"
          >
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
};
